const initialState = null;

const ReservationSalesChannel = (state = initialState, action) => {
  switch (action.type) {
    case "setreservationSalesChannel":
      state = action.payload;
      return state;
    default:
      return state;
  }
};

export default ReservationSalesChannel;
